import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends ApiService {

  public getStrategies(data: any) {
    return this.getQueryParams(CONSTANTS.API.CLIENT.GET_STRATEGIES, data);
  }

  public closeLeg(data: any) {
    return this.getQueryParams(CONSTANTS.API.CLIENT.CLOSE_LEG, data);
  }

  public getReport(data: any) {
    return this.getQueryParams(CONSTANTS.API.CLIENT.GET_REPORTS, data);
  }
}
